import { ColorScheme, getColor } from '@webapp/common/lib/ui';

export const DEFAULT_BUTTON_COLOR = ['#92e2fbff', '#318fffff', '#1c61ffff'];

export interface SurveyAddonFonts {
    buttonBorderRadius?: number;
    buttonColor: string;
    buttonHeight?: number;
    buttonTextColor: ColorScheme;
    buttonWidth?: number;
    customFontFamily: string;
    elementColor: string;
    fieldBorderColor: string;
    fieldColor: string;
    fontColor: string;
    fontFamily: string;
    questionTextBold: boolean;
    questionTextColor: string;
    questionTextItalic: boolean;
    questionTextSize: number;
    questionTextThrough: boolean;
    questionTextUnderline: boolean;
    replyTextBold: boolean;
    replyTextColor: string;
    replyTextItalic: boolean;
    replyTextSize: number;
    replyTextThrough: boolean;
    replyTextUnderline: boolean;
    titleBold: boolean;
    titleColor: string;
    titleItalic: boolean;
    titleSize: number;
    titleThrough: boolean;
    titleUnderline: boolean;
}

export const initialSurveyAddonFonts: Readonly<SurveyAddonFonts> = {
    buttonBorderRadius: 12,
    buttonColor: JSON.stringify(DEFAULT_BUTTON_COLOR),
    buttonHeight: 40,
    buttonTextColor: ColorScheme.LIGHT,
    buttonWidth: 164,
    customFontFamily: '',
    elementColor: getColor('blue'),
    fieldBorderColor: getColor('blue'),
    fieldColor: getColor('blue'),
    fontColor: getColor('black'),
    fontFamily: 'Montserrat',
    questionTextBold: true,
    questionTextColor: getColor('grey3'),
    questionTextItalic: false,
    questionTextSize: 21,
    questionTextThrough: false,
    questionTextUnderline: false,
    replyTextBold: false,
    replyTextColor: getColor('grey3'),
    replyTextItalic: false,
    replyTextSize: 16,
    replyTextThrough: false,
    replyTextUnderline: false,
    titleBold: true,
    titleColor: getColor('grey3'),
    titleItalic: false,
    titleSize: 30,
    titleThrough: false,
    titleUnderline: false,
};
